module.exports = __webpack_public_path__ + "static/img/m_name.1884b36.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/kr/m_name.png
// module id = KsOX
// module chunks = 7